import React from "react";
import { Snackbar, Alert } from "@mui/material";

interface ToastSnackbarProps {
  open: boolean;
  onClose: () => void;
  message: string;
  severity?: "error" | "warning" | "info" | "success";
  autoHideDuration?: number;
}

const ToastSnackbar: React.FC<ToastSnackbarProps> = ({
  open,
  onClose,
  message,
  severity = "success",
  autoHideDuration = 3000,
}) => (
  <Snackbar
    open={open}
    autoHideDuration={autoHideDuration}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
  >
    <Alert onClose={onClose} severity={severity} sx={{ width: "100%" }}>
      {message}
    </Alert>
  </Snackbar>
);

export default ToastSnackbar;
